import createAsyncComponent from '@core-ui-utils/async/createAsyncComponent'


export default {
  install: (Vue, options) => {
    // registered as an async component, so the ag grid payload is only fetched once a grid renders
    // the component name matches the synchronous entry, so consumer templates are identical
    const GuDatagridClient = createAsyncComponent({
      loader: () => import(/* webpackChunkName: "gu-datagrid-client" */'@gu-datagrid/components/GuDatagridClient.vue'),
      loadingMessage: 'Loading datagrid…',
      errorMessage: 'The datagrid could not be loaded.'
    })
    Vue.component('GuDatagridClient', GuDatagridClient)
  }
}
